module.exports = __webpack_public_path__ + "media/images/logo-note-9c7ab605a627d914757caede4bbee56e.svg";